<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->
<div class="auth-center-all core-container-content">
	<router-outlet></router-outlet>
</div>
